import React, {Fragment} from "react";
import {ApplicationState, ConnectedReduxProps} from "@reducers/index";
import {supplier} from "@models/supplier";
import PaymentForm from "@components/supplier/Payment";
import {injectIntl} from "react-intl";
import supplierApi from "@api/supplier";


interface PropsFromState {
  loading: boolean;
  data: supplier[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class SupplierPaymentFormPage extends React.Component<AllProps> {
  state = {
    supplier: null,
    id: this.props.match.params.id,
    supplier_id: this.props.match.params.supplier_id,
    is_fetched: false
  };
  
  componentDidMount() {
    if (this.state.id) {
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    supplierApi.getPaymentById({
        params: {
          supplier_id: this.state.supplier_id,
          id: this.state.id,
        }
      })
      .then(({data}) => {
        this.setState({
          supplierPayment: data
        });
      })
      .catch(error => {
      });
  };
  
  updateRequest = ({payload, params, onSuccessCallback, onErrorCallback, id}) => {
    supplierApi.updatePayment({
        payload,
        params:{
          supplier_id : payload.supplier_id,
          id : params.id
        },
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  createRequest = ({payload, onSuccessCallback, onErrorCallback}) => {
    supplierApi.addPayment({
        payload,
        params:{
          supplier_id : payload.supplier_id,
        },
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  getContent = () => {
    if (this.state.supplier_id && !this.state.supplierPayment) {
      return null;
    }
    
    return (
      <PaymentForm
        supplierPayment={this.state.supplierPayment}
        intl={this.props.intl}
        listUrl={"/reports/suppliers/payments"}
        history={this.props.history}
        updateRequest={this.updateRequest}
        createRequest={this.createRequest}
      />
    );
  };
  
  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}


export default injectIntl(SupplierPaymentFormPage)
